import { Configuration, ILoggerCallback, LogLevel } from "@azure/msal-browser";
import { SIGN_IN_URL, SIGN_IN_URL_B2C, CLIENT_ID, CLIENT_ID_B2C, REDIRECT_URI, FORGOT_PASSWORD_URL, SIGN_UP_URL, CHANGE_PASSWORD_URL } from '../config/env'

const knownAuthorities = [
    SIGN_IN_URL,
    SIGN_IN_URL_B2C,
    FORGOT_PASSWORD_URL
]

export class AuthConfig {
  pcaConfig: Configuration;
  b2cConfig: Configuration;
  forgotPasswordConfig: Configuration;
  signupConfig: Configuration;
  changePasswordConfig: Configuration;

  constructor() {
    this.pcaConfig = {
        auth: {
            clientId: CLIENT_ID,
            authority: SIGN_IN_URL,
            redirectUri: REDIRECT_URI,
            knownAuthorities: knownAuthorities,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: this.handleCallback
            },
        },
    };
    
    this.b2cConfig = {
        auth: {
            clientId: CLIENT_ID_B2C,
            authority: SIGN_IN_URL_B2C,
            redirectUri: REDIRECT_URI,
            knownAuthorities: knownAuthorities,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: this.handleCallback
            },
        },
    };

    this.forgotPasswordConfig = {
        auth: {
            clientId: CLIENT_ID_B2C,
            authority: FORGOT_PASSWORD_URL,
            redirectUri: REDIRECT_URI,
            knownAuthorities: knownAuthorities,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: this.handleCallback
            },
        },
    };

    this.signupConfig = {
        auth: {
            clientId: CLIENT_ID_B2C,
            authority: SIGN_UP_URL,
            redirectUri: REDIRECT_URI,
            knownAuthorities: knownAuthorities,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: this.handleCallback
            },
        },
    };

    this.changePasswordConfig = {
        auth: {
            clientId: CLIENT_ID_B2C,
            authority: CHANGE_PASSWORD_URL,
            redirectUri: REDIRECT_URI,
            knownAuthorities: knownAuthorities,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: this.handleCallback
            },
        },
    };
  }

  handleCallback = (level: any, message: any, containsPii: any) : ILoggerCallback | void => {
    if (containsPii) {
        return;
    }
    switch (level) {
        case LogLevel.Error:
            console.error(message);
            return;
        case LogLevel.Info:
            console.info(message);
            return;
        case LogLevel.Verbose:
            console.debug(message);
            return;
        case LogLevel.Warning:
            console.warn(message);
            return;
    }
  }
}